export { default } from './TempsLectura';
